// extracted by mini-css-extract-plugin
export default {"popover-paper":"SubMenu_popover-paper__NOfFY","popoverPaper":"SubMenu_popover-paper__NOfFY","popover-root":"SubMenu_popover-root__U4G6W","popoverRoot":"SubMenu_popover-root__U4G6W"};